module.exports = __webpack_public_path__ + "static/img/280_phase_function_Paper_PointsHejduk_Prediction.9b78c71.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/280_phase_function_Paper_PointsHejduk_Prediction.png
// module id = u7Ex
// module chunks = 0